import { useState } from 'react';
import { FolderOpen } from 'lucide-react';
import FileViewer from './FileViewer';
import FileTypeIcon from './FileTypeIcon';

function FileItem({ file, onClick }) {
    return (
        <button
            onClick={() => onClick(file)}
            className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-left hover:bg-gray-50 transition-colors group"
        >
            <span className="flex-shrink-0">
                <FileTypeIcon iconType={file.icon_type} size={20} />
            </span>
            <span className="text-[13px] text-gray-700 truncate flex-1 group-hover:text-gray-900">
                {file.filename}
            </span>
            <span className="text-[10px] text-gray-400 flex-shrink-0 uppercase">
                {file.source === 'upload' ? 'upload' : ''}
            </span>
        </button>
    );
}

export default function WorkingFolderPanel({ files, sessionId }) {
    const [selectedFile, setSelectedFile] = useState(null);

    if (!files || files.length === 0) return null;

    return (
        <>
            <div className="border border-gray-200 rounded-2xl bg-white shadow-sm">
                <div className="flex items-center justify-between px-4 py-3">
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-semibold text-gray-700">Danh sách tệp</span>
                    </div>
                </div>
                <div className="px-2 pb-2 space-y-0.5 max-h-[40vh] overflow-y-auto">
                    {files.map((file, index) => (
                        <FileItem key={file.path || index} file={file} onClick={setSelectedFile} />
                    ))}
                </div>
            </div>

            {selectedFile && (
                <FileViewer
                    file={selectedFile}
                    sessionId={sessionId}
                    onClose={() => setSelectedFile(null)}
                />
            )}
        </>
    );
}
